module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-2-photo-2-b2a36423cd7cb17c48bb9289d13061ca.webp";